import data from "../../../../../src/AvatarStack/AvatarStack.docs.json";
import { AvatarStack } from '@primer/react';
import DeprecationBanner from "../../../../components/DeprecationBanner";
import * as React from 'react';
export default {
  data,
  AvatarStack,
  DeprecationBanner,
  React
};